import React from 'react';
import uuid from 'uuid/v4';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import i18n from 'i18next'
class InfoTooltip extends React.Component {
  render() {
    return (
      <OverlayTrigger
        placement={this.props.placement || "top" }
        overlay={(
          <Tooltip id={uuid()}>
            {i18n.t(this.props.info)}
          </Tooltip>
                )}
      >
        {this.props.children}
      </OverlayTrigger>
    );
  }
}

export default InfoTooltip;



// WEBPACK FOOTER //
// ./src/components/common/tooltip/info/index.js